'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Radio = _ref => {
  let {
    fill,
    stroke,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "19",
    height: "19",
    rx: "9.5",
    fill: "transparent",
    stroke: stroke
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "4.5",
    y: "4.5",
    width: "11",
    height: "11",
    rx: "5.5",
    fill: fill,
    stroke: fill
  }));
};
const RadioSelected = _ref2 => {
  let {
    style,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(Radio, _extends__default["default"]({
    fill: style === null || style === void 0 ? void 0 : style.fill,
    stroke: style === null || style === void 0 ? void 0 : style.fill
  }, rest));
};
const RadioUnselected = _ref3 => {
  let {
    style,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement(Radio, _extends__default["default"]({
    fill: "transparent",
    stroke: style === null || style === void 0 ? void 0 : style.fill
  }, rest));
};
/* eslint-enable react/prop-types */

exports.RadioSelected = RadioSelected;
exports.RadioUnselected = RadioUnselected;
